import { render, staticRenderFns } from "./ApprovalGoods.vue?vue&type=template&id=0bdc54d8"
import script from "./ApprovalGoods.vue?vue&type=script&lang=js"
export * from "./ApprovalGoods.vue?vue&type=script&lang=js"
import style0 from "./ApprovalGoods.vue?vue&type=style&index=0&id=0bdc54d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports